import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem } from '@mui/material';

export default function AdminUserEditDialog({ open, user, onClose, onSave }) {
  const [form, setForm] = useState(user || {});

  React.useEffect(() => {
    setForm(user || {});
  }, [user]);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    onSave(form);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Edit User</DialogTitle>
      <DialogContent>
        <TextField margin="dense" label="Full Name" name="full_name" value={form.full_name || ''} onChange={handleChange} fullWidth />
        <TextField margin="dense" label="Email" name="email" value={form.email || ''} onChange={handleChange} fullWidth />
        <TextField margin="dense" label="Phone" name="phone" value={form.phone || ''} onChange={handleChange} fullWidth />
        <TextField margin="dense" label="Account Type" name="account_type" value={form.account_type || ''} onChange={handleChange} select fullWidth>
          <MenuItem value="savings">Savings</MenuItem>
          <MenuItem value="current">Current</MenuItem>
        </TextField>
        <TextField margin="dense" label="Account Status" name="status" value={form.status || ''} onChange={handleChange} select fullWidth>
          <MenuItem value="active">Active</MenuItem>
          <MenuItem value="dormant">Dormant/Inactive</MenuItem>
          <MenuItem value="closed">Closed</MenuItem>
          <MenuItem value="disabled">Disabled</MenuItem>
          <MenuItem value="suspicious">Suspicious Login</MenuItem>
          <MenuItem value="frozen">Frozen Account</MenuItem>
          <MenuItem value="irs">IRS</MenuItem>
        </TextField>
        <TextField margin="dense" label="Role" name="role" value={form.role || ''} onChange={handleChange} select fullWidth>
          <MenuItem value="user">User</MenuItem>
          <MenuItem value="admin">Admin</MenuItem>
        </TextField>
        <TextField margin="dense" label="Balance" name="balance" value={form.balance || ''} onChange={handleChange} type="number" fullWidth />
        <TextField margin="dense" label="Address" name="address" value={form.address || ''} onChange={handleChange} fullWidth />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}
